import { CircleDollarSign, HeartPulse, ShoppingCart, Users } from 'lucide-react';
import { VaniaMetricCard } from '@vanialabs/ui-engine';
import { formatPersianNumber } from '../../../app/components/foundation';
import type { MonitoringSnapshot } from '../../monitoring/types/monitoring.types';
import type { DashboardOverview } from '../types/dashboard.types';
import { getControlPlaneMetricValues } from './controlPlaneMetrics.model';

interface ControlPlaneMetricsProps {
  dashboard: DashboardOverview;
  monitoring: MonitoringSnapshot | null;
  monitoringLoading: boolean;
}

export function ControlPlaneMetrics({ dashboard, monitoring, monitoringLoading }: ControlPlaneMetricsProps) {
  const { systemHealth } = getControlPlaneMetricValues(dashboard, monitoring, monitoringLoading);
  const metrics = [
    { label: 'درآمد کل', value: `${formatPersianNumber(dashboard.overview.total_revenue)} تومان`, icon: CircleDollarSign },
    { label: 'کاربران فعال', value: dashboard.overview.active_users, icon: Users },
    { label: 'سفارش‌ها', value: dashboard.overview.total_orders, icon: ShoppingCart },
    { label: 'سلامت سیستم', value: systemHealth, icon: HeartPulse },
  ] as const;

  return <div className="vania-control-plane-metrics">
    {metrics.map(({ label, value, icon: Icon }) => <VaniaMetricCard key={label} label={label} value={typeof value === 'number' ? formatPersianNumber(value) : value} icon={<Icon size={18} />} />)}
  </div>;
}
